import { h } from 'preact'
import { connectCurrentRefinements } from 'react-instantsearch-dom'
import Phrase from '../../libs/translationsUtils/phrase'
import Icon from '../assets'

type Item = {
  attribute: 'tags' | 'categories.lvl0' | 'kb.categories.lvl0' | 'content_type' | 'source',
  currentRefinement: Array<Object>,
  value: string
}

interface Props {
  items: Array<Item>,
  refine: Function,
  resetSources: () => void
}

const getTitleOfFilter = (item: Item) => {
  const titleMap = {
    tags: <Phrase m='Common' p='advanced.search.filter.tag' />,
    source: <Phrase m='Common' p='advanced.search.filter.source' />,
    content_type: <Phrase m='Common' p='advanced.search.filter.topic.type' />
  }

  if (item.attribute === 'categories.lvl0') {
    return <span>
      <Phrase m='Common' p='advanced.search.filter.category' />: {item.currentRefinement}
    </span>
  }

  if (item.attribute === 'kb.categories.lvl0') {
    return <span>
      <Phrase m='Common' p='advanced.search.filter.category' />: {item.currentRefinement}
    </span>
  }
  return titleMap[item.attribute]
}

const CurrentRefinements = (props: Props) => {
  if (!props.items.length) {
    return
  }
  return (
    <ul className='instant-search__filters-list'>
      {
        props.items.map(item => (
          <li className='instant-search__filter-list-pill'>
            <span className='instant-search__filter-name'>{ getTitleOfFilter(item) }</span>
            {
              item.attribute === 'tags' || item.attribute === 'content_type' || item.attribute === 'source' ? (
                <span className='instant-search__filter-count'>{item.currentRefinement.length}</span>
              ) : null
            }
            <span
              className='instant-search__filter-dismiss'
              onClick={event => {
                event.preventDefault()
                event.stopPropagation()
                props.refine(item.value)
                if (item.attribute === 'source') {
                  props.resetSources()
                }
              }}>
              <Icon icon='close' width={16} height={16} color={'#fff'} />
            </span>
          </li>)
        )
      }
    </ul>
  )
}

const CustomCurrentRefinements = connectCurrentRefinements(CurrentRefinements)

export default CustomCurrentRefinements
